import * as api from '../../api/api-cierre-gestion';
import {
    GET_CONFIG_FORM19,
    GET_DATOS_CIERRE,
    GET_COMBO_REGISTRAR_HITO,
    POST_ACTUALIZAR_CIERRE,
    GET_MEDIOS_PAGO,
    GET_BANCOS,
    GET_MAX_NRO_CUOTAS,
    GET_CALCULO_MONTO_CUOTA
} from '../types';

export const configuracionFormAction19 = (query) => ({
    type: GET_CONFIG_FORM19,
    payload: api.getConfiguracionForm19(query)
});
export const obtenerDatosCierreGestion = (query) => ({
    type: GET_DATOS_CIERRE,
    payload: api.getDatosCierreGetion(query)
});
export const obtenerComboRegistrarHito = (query) => ({
    type: GET_COMBO_REGISTRAR_HITO,
    payload: api.getComboRegistrarHito(query)
});
export const postActualizarCierre = (query) => ({
    type: POST_ACTUALIZAR_CIERRE,
    payload: api.postActualizarCierre(query)
});
export const obtenerMediosPago = (query) => ({
    type: GET_MEDIOS_PAGO,
    payload: api.getMediosPago(query)
});
export const obtenerMaxNroCuotas = (query) => ({
    type: GET_MAX_NRO_CUOTAS,
    payload: api.getMaxNumeroCuotas(query)
});
export const obtenerBancos = (query) => ({
    type: GET_BANCOS,
    payload: api.getBancos(query)
});
export const obtenerCalculoMontoCuota = (query) => ({
    type: GET_CALCULO_MONTO_CUOTA,
    payload: api.getCalculoMontoCuota(query)
});